var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "currentColor",
    d: "M 20 6 L 12 6 L 10.589844 4.589844 C 10.210938 4.210938 9.699219 4 9.167969 4 L 4 4 C 2.898438 4 2.011719 4.898438 2.011719 6 L 2 18 C 2 19.101562 2.898438 20 4 20 L 20 20 C 21.101562 20 22 19.101562 22 18 L 22 8 C 22 6.898438 21.101562 6 20 6 Z M 19 18 L 5 18 C 4.449219 18 4 17.550781 4 17 L 4 9 C 4 8.449219 4.449219 8 5 8 L 19 8 C 19.550781 8 20 8.449219 20 9 L 20 17 C 20 17.550781 19.550781 18 19 18 Z M 19 18 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/FolderOpen.d797d24ea32b48625cb274aba1d89684.svg";
export { ForwardRef as ReactComponent };